import { numberWithCommas, roundNumber } from './functions';
import moment from 'moment';
import { datePattern } from './constants';

const dateDisplayFormat = 'MM/DD/YYYY';

export const formatQty = (data) => {
  if (data.value) {
    return numberWithCommas(data.value);
  }
  return '-';
};

export const formatPrice = (data) => {
  if (data.value) {
    return numberWithCommas(roundNumber(data.value, 4));
  }
  return '-';
};

export const formatTradeDate = (rowData) => {
  if (rowData) {
    return moment(rowData.tradeDate, datePattern).format(dateDisplayFormat);
  }
  return '';
};
